import { render, staticRenderFns } from "./QueryItemSliderLabel.vue?vue&type=template&id=b3127f84&scoped=true"
import script from "./QueryItemSliderLabel.vue?vue&type=script&lang=js"
export * from "./QueryItemSliderLabel.vue?vue&type=script&lang=js"
import style0 from "./QueryItemSliderLabel.vue?vue&type=style&index=0&id=b3127f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3127f84",
  null
  
)

export default component.exports